import { type PropsWithClassName } from "@/components/podkit/lib/cn";
import { useId, useRef, type FC } from "react";

export const PhpStormLogo: FC<PropsWithClassName> = ({ className }) => {
    const id = useRef(useId()).current;

    return (
        <svg
            className={className}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M13.5771 5.21143L12.4457 1.78286L4.08 0L0 4.62857L12.7543 11.1429L13.5771 5.21143Z"
                fill={`url(#paint0_linear_${id})`}
            />
            <path
                d="M9.6 14.1943L9.36 7.06283L0 4.62854L2.29714 18.3771L9.6 18.3085V14.1943Z"
                fill={`url(#paint1_linear_${id})`}
            />
            <path
                d="M7.57714 14.0571L8.02286 8.39994L14.8114 1.43994L20.88 2.53708L24 10.3199L20.7429 13.5428L15.4286 12.6857L12.1371 16.1485L7.57714 14.0571Z"
                fill={`url(#paint2_linear_${id})`}
            />
            <path
                d="M14.8114 1.43994L5.07429 10.0799L6.96 21.1885L15.0514 23.9999L24 18.6514L14.8114 1.43994Z"
                fill={`url(#paint3_linear_${id})`}
            />
            <path d="M19.4057 4.59424H4.59428V19.4057H19.4057V4.59424Z" fill="black" />
            <path d="M11.5543 16.6285H6V17.5543H11.5543V16.6285Z" fill="white" />
            <path
                d="M5.93143 6.51428H8.43428C9.90857 6.51428 10.8 7.37143 10.8 8.64V8.67428C10.8 10.1143 9.70286 10.8343 8.29714 10.8343H7.26857V12.6857H5.93143V6.51428ZM8.36571 9.6C9.05143 9.6 9.42857 9.18857 9.42857 8.67428V8.64C9.42857 8.02285 9.01714 7.71428 8.33143 7.71428H7.30286V9.6H8.36571Z"
                fill="white"
            />
            <path
                d="M11.1429 11.7942L11.9314 10.8342C12.48 11.2799 13.0629 11.5885 13.7829 11.5885C14.3314 11.5885 14.6743 11.3828 14.6743 11.0057V10.9714C14.6743 10.6285 14.4686 10.4571 13.44 10.1828C12.2057 9.87423 11.3829 9.53138 11.3829 8.29709V8.26281C11.3829 7.13138 12.2743 6.41138 13.5429 6.41138C14.4343 6.41138 15.2229 6.68566 15.84 7.19995L15.12 8.22852C14.5714 7.85138 14.0229 7.61138 13.5086 7.61138C12.9943 7.61138 12.72 7.85138 12.72 8.15995V8.19423C12.72 8.60566 12.9943 8.74281 14.0571 9.01709C15.2914 9.35995 16.0114 9.80566 16.0114 10.8685V10.9028C16.0114 12.1371 15.0857 12.8228 13.7486 12.8228C12.8229 12.7885 11.8971 12.4457 11.1429 11.7942Z"
                fill="white"
            />
            <defs>
                <linearGradient
                    id={`paint0_linear_${id}`}
                    x1="0.191315"
                    y1="16.0614"
                    x2="10.2676"
                    y2="2.75163"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.016129" stopColor="#765AF8" />
                    <stop offset="0.3821" stopColor="#B345F1" />
                    <stop offset="0.7581" stopColor="#FA3293" />
                    <stop offset="0.9409" stopColor="#FF318C" />
                </linearGradient>
                <linearGradient
                    id={`paint1_linear_${id}`}
                    x1="0.935897"
                    y1="16.587"
                    x2="10.9961"
                    y2="3.29856"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.016129" stopColor="#765AF8" />
                    <stop offset="0.3821" stopColor="#B345F1" />
                    <stop offset="0.7581" stopColor="#FA3293" />
                    <stop offset="0.9409" stopColor="#FF318C" />
                </linearGradient>
                <linearGradient
                    id={`paint2_linear_${id}`}
                    x1="17.4366"
                    y1="15.9102"
                    x2="11.7511"
                    y2="2.41643"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.1828" stopColor="#765AF8" />
                    <stop offset="0.2382" stopColor="#8655F6" />
                    <stop offset="0.3449" stopColor="#9F4CF3" />
                    <stop offset="0.4425" stopColor="#AE47F2" />
                    <stop offset="0.5219" stopColor="#B345F1" />
                </linearGradient>
                <linearGradient
                    id={`paint3_linear_${id}`}
                    x1="21.6911"
                    y1="19.659"
                    x2="8.46778"
                    y2="9.43393"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.016129" stopColor="#765AF8" />
                    <stop offset="0.3821" stopColor="#B345F1" />
                </linearGradient>
            </defs>
        </svg>
    );
};
